var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 142,
    viewBox: "0 0 287 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_72264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.7069,
    y: 37,
    width: 221.586,
    height: 68,
    rx: 8,
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7069,
    y: 37,
    width: 68,
    height: 68,
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M77.3319 84V67H69.8944C69.009 66.9557 68.2564 66.6458 67.6366 66.0703C67.0611 65.4505 66.7512 64.6979 66.7069 63.8125V56.375H58.2069C57.5871 56.375 57.078 56.5742 56.6796 56.9727C56.2811 57.3711 56.0819 57.8802 56.0819 58.5V84C56.0819 84.6198 56.2811 85.1289 56.6796 85.5273C57.078 85.9258 57.5871 86.125 58.2069 86.125H75.2069C75.8267 86.125 76.3358 85.9258 76.7342 85.5273C77.1327 85.1289 77.3319 84.6198 77.3319 84ZM77.3319 64.875C77.2434 64.6979 77.1327 64.543 76.9999 64.4102L69.2967 56.707C69.1639 56.5742 69.009 56.4857 68.8319 56.4414V63.8125C68.8762 64.4766 69.2303 64.8307 69.8944 64.875H77.3319ZM53.9569 58.5C54.0012 57.3047 54.4217 56.3086 55.2186 55.5117C56.0155 54.7148 57.0116 54.2943 58.2069 54.25H68.5663C69.4517 54.25 70.2043 54.5599 70.8241 55.1797L78.5272 62.8828C79.147 63.5026 79.4569 64.2552 79.4569 65.1406V84C79.4126 85.1953 78.9921 86.1914 78.1952 86.9883C77.3983 87.7852 76.4022 88.2057 75.2069 88.25H58.2069C57.0116 88.2057 56.0155 87.7852 55.2186 86.9883C54.4217 86.1914 54.0012 85.1953 53.9569 84V58.5ZM58.2069 59.5625C58.2512 58.8984 58.6053 58.5443 59.2694 58.5H63.5194C64.1835 58.5443 64.5376 58.8984 64.5819 59.5625C64.5376 60.2266 64.1835 60.5807 63.5194 60.625H59.2694C58.6053 60.5807 58.2512 60.2266 58.2069 59.5625ZM58.2069 63.8125C58.2512 63.1484 58.6053 62.7943 59.2694 62.75H63.5194C64.1835 62.7943 64.5376 63.1484 64.5819 63.8125C64.5376 64.4766 64.1835 64.8307 63.5194 64.875H59.2694C58.6053 64.8307 58.2512 64.4766 58.2069 63.8125ZM67.7694 70.4531V71.3164C68.3449 71.4049 68.8762 71.5156 69.3631 71.6484C69.9829 71.8255 70.2486 72.2461 70.16 72.9102C69.9387 73.5299 69.496 73.7956 68.8319 73.707C68.0793 73.5299 67.371 73.4193 66.7069 73.375C66.0871 73.375 65.5337 73.4857 65.0467 73.707C64.6926 73.9284 64.5376 74.1497 64.5819 74.3711C64.5376 74.4596 64.6926 74.6146 65.0467 74.8359C65.4894 75.0573 66.1314 75.2565 66.9725 75.4336L67.0389 75.5C67.8358 75.6771 68.6327 75.9427 69.4296 76.2969C70.315 76.7396 70.8241 77.5365 70.9569 78.6875C70.8684 79.9714 70.3371 80.8346 69.3631 81.2773C68.8762 81.543 68.3449 81.7201 67.7694 81.8086V82.7383C67.7251 83.3581 67.371 83.7122 66.7069 83.8008C66.0428 83.7122 65.6887 83.3581 65.6444 82.7383V81.7422C64.9361 81.6094 64.272 81.4544 63.6522 81.2773C63.5194 81.2331 63.4087 81.1888 63.3202 81.1445C63.2759 81.1445 63.2538 81.1445 63.2538 81.1445C62.634 80.8789 62.3905 80.4362 62.5233 79.8164C62.7447 79.1966 63.1874 78.9531 63.8514 79.0859C63.9842 79.1302 64.1392 79.1745 64.3163 79.2188C65.2017 79.5286 66.0207 79.7057 66.7733 79.75C67.3931 79.75 67.9243 79.6393 68.3671 79.418C68.7212 79.2409 68.8762 79.0195 68.8319 78.7539C68.8762 78.5768 68.7212 78.3776 68.3671 78.1562C67.9243 77.9349 67.2824 77.7135 66.4413 77.4922H66.3085C66.3085 77.4922 66.2863 77.4922 66.2421 77.4922C65.4894 77.3151 64.759 77.0495 64.0506 76.6953C63.121 76.2969 62.5897 75.5221 62.4569 74.3711C62.5897 73.0872 63.1431 72.2461 64.1171 71.8477C64.604 71.582 65.1131 71.4049 65.6444 71.3164V70.4531C65.7329 69.7891 66.0871 69.4349 66.7069 69.3906C67.371 69.4349 67.7251 69.7891 67.7694 70.4531Z",
    fill: "#706B85"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 12.801,
    transform: "translate(110.707 53)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119.586,
    height: 19,
    transform: "translate(110.707 69.801)",
    fill: "#DEDEE6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.2069,
    y: 37.5,
    width: 220.586,
    height: 67,
    rx: 7.5,
    stroke: "#CECEDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_72264"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.7069,
    y: 37,
    width: 221.586,
    height: 68,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsPlaceholder);
export default __webpack_public_path__ + "static/media/payments-placeholder.c173fbd2f321d306cd47696df67b7d4b.svg";
export { ForwardRef as ReactComponent };